/**
 * Retourne la couleur Tailwind correspondant à l'écart budget.
 *
 * Règle CDC §3.1.6 :
 *  < 5 %  → vert
 *  5-15 % → orange
 *  > 15 % → rouge
 *
 * Cas particulier : budget = 0 et realized > 0 → rouge (dépassement infini)
 * Cas particulier : realized <= budget → vert (pas de dépassement)
 */
export function colorForVariance(realizedCents, budgetCents) {
  if (budgetCents === 0 || budgetCents === null || budgetCents === undefined) {
    return realizedCents > 0 ? 'red' : 'green';
  }

  const pct = ((realizedCents - budgetCents) / Math.abs(budgetCents)) * 100;

  if (pct < 5) return 'green';
  if (pct <= 15) return 'orange';
  return 'red';
}

/**
 * Retourne les classes Tailwind text + bg pour un niveau de variance.
 */
export function varianceClasses(realizedCents, budgetCents) {
  const color = colorForVariance(realizedCents, budgetCents);
  switch (color) {
    case 'green':
      return { text: 'text-green-600', bg: 'bg-green-100', badge: 'bg-green-100 text-green-700' };
    case 'orange':
      return { text: 'text-orange-500', bg: 'bg-orange-100', badge: 'bg-orange-100 text-orange-700' };
    case 'red':
    default:
      return { text: 'text-red-600', bg: 'bg-red-100', badge: 'bg-red-100 text-red-700' };
  }
}
